/**
 * trustedAdvisor模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const trustedAdvisor = {
  // 查询检查项
  listTrustedAdvisorCheckItems(id,params){
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/trustedAdvisor/listTrustedAdvisorCheckItems`,param);

  },
  // 查看受影响的资源
  checkAWSTrustedAdvisorAffectedResources(params) {
    return $http.post(`${global.API_URL}/sme/trustedAdvisor/checkAWSTrustedAdvisorAffectedResources`,params);
  },
  // 查询TrustedAdvisor的统计详情
  checkAWSTrustedAdvisorDetailByType(params) {
    return $http.post(`${global.API_URL}/sme/trustedAdvisor/checkAWSTrustedAdvisorDetailByType`,params);
  },
  // 查询TrustedAdvisor的总览信息
  checkAWSTrustedAdvisorOverview(params) {
    return $http.post(`${global.API_URL}/sme/trustedAdvisor/checkAWSTrustedAdvisorOverview`,params);
  }
}

export default trustedAdvisor;



// WEBPACK FOOTER //
// ./src/api/trustedAdvisor.js